
export function isLocationData(obj: any): boolean {
  return obj && obj.target && obj.detail;
}